var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductteardownBro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.86,219.8s-4.73,4.1-6.62,8.83-1.58,9.47-6.31,11-7.57,0-7.57,0,3.78-9.46,6-12.62S366.86,219.8,366.86,219.8Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.38,80.56s-11.86,30.71-16.59,39.23-10.73,11-17.67,13.88-26.5,15.14-28.4,19.88-4.1,18.93-6,23.66-5.68,7.25-11.36,8.83-11.67,2.53-10.72,5.36,10.09,4.74,19.24,3.48,12.62-3.79,15.46-7.58,7.57-12,9.46-12.93l1.9-1s-.32,33.76.31,37.86-2.84,18.3-9.78,35.34-1.89,28.39.32,30.6,6.62,2.21,7.57,1.26.32-13.57,2.21-21.77,12.93-30,16.09-34.39a114.86,114.86,0,0,0,6.62-11,136.58,136.58,0,0,1-7.88,30c-6.31,16.41-12.94,27.13-14.2,31.87s3.47,7.57,6.31,6.31,8.83-13.89,11-18.3S337.84,246,337.84,246A10.11,10.11,0,0,0,347,242.2c3.78-4.73,9.78-14.51,9.78-14.51s8.83-4.74,10.09-7.89,3.47-33.76,5.37-44.49,7.25-33.75,10.09-42.9,23.54-48.69,23.54-48.69",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.39,83s10.76,38.4,13,43.13,14.19,12.3,16.4,22.71,5.05,14.83,7.57,22.72,4.74,7.89.95,14.51-4.42,10.73-1.89,14.83,15.46,9.46,13.88,12.62-3.16,4.1-4.42,4.1h-1.26s2.84,10.41,1.26,14.2-5.36,6.31-6.62,4.41-3.47-4.73-3.47-4.73,2.52,5.05-.63,5.68-3.79-.31-8.52-2.52-15.46-4.42-15.46-4.42-12.62,5-16.72,6.31-9.15-.32-9.15-.32-13.57,5.37-15.78,1-3.78-22.71-4.73-26.18-4.1-6.31-3.47-11.68,2.21-8.52,2.53-10.72,8.51-42.28,8.51-51.11-15.45-53-15.45-53",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.65,396.3S149.73,444.85,218.47,443s127.66-48.15,176.38-84.39,62.14-93,34.23-137.53-72.89-26.18-129.84-55.38-67.69-45.61-131.39-39S55.17,204.48,61.88,280.8,106.65,396.3,106.65,396.3Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.65,396.3S149.73,444.85,218.47,443s127.66-48.15,176.38-84.39,62.14-93,34.23-137.53-72.89-26.18-129.84-55.38-67.69-45.61-131.39-39S55.17,204.48,61.88,280.8,106.65,396.3,106.65,396.3Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 215.84,
    y: 223.45,
    width: 148.28,
    height: 70.04,
    rx: 5.49,
    transform: "translate(548.46 -31.51) rotate(90)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.91,
    y: 221.69,
    width: 148.28,
    height: 70.04,
    rx: 5.49,
    transform: "translate(543.76 -30.33) rotate(90)",
    style: {
      fill: "#b5b5b5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.58,182.57H257.51a5.48,5.48,0,0,0-5.48,5.49v3.34h70v-3.34A5.48,5.48,0,0,0,316.58,182.57Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.13,
    y: 198.66,
    width: 44.8,
    height: 73.19,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,323v2.4a5.48,5.48,0,0,0,5.48,5.49h59.07a5.48,5.48,0,0,0,5.48-5.49V323Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.94,
    y: 307.82,
    width: 13.88,
    height: 15.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.67,307.82a4.1,4.1,0,1,0-4.1,4.1A4.1,4.1,0,0,0,293.67,307.82Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288.31,
    y1: 303.72,
    x2: 288.31,
    y2: 271.85,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.13,
    y: 281.32,
    width: 12.93,
    height: 16.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.88,
    y: 322.96,
    width: 12.62,
    height: 7.89,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.9 214.89 280.19 214.89 272.33 233.06 278 233.06 271.33 250.89 286.67 228.39 280.67 228.39 286.9 214.89",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.55,341.34h10.29v70H161.55a5.48,5.48,0,0,1-5.48-5.48V346.83A5.48,5.48,0,0,1,161.55,341.34Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.71,339.81H170v70H159.71a5.48,5.48,0,0,1-5.48-5.49V345.29A5.48,5.48,0,0,1,159.71,339.81Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.86,341.57H351.57v30.14a6,6,0,1,1,0,9.76v30.14h10.29a5.49,5.49,0,0,0,5.49-5.49V347.06A5.49,5.49,0,0,0,361.86,341.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.1,339.81H349.81V370a6,6,0,1,1,0,9.76v30.14H360.1a5.48,5.48,0,0,0,5.48-5.49V345.29A5.48,5.48,0,0,0,360.1,339.81Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.35,
    y: 342.16,
    width: 148.28,
    height: 70.04,
    rx: 5.49,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.83,
    y: 339.81,
    width: 148.28,
    height: 70.04,
    rx: 5.49,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.54,
    y: 341.38,
    width: 144.86,
    height: 66.9,
    rx: 5.49,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,343.91h98.83a0,0,0,0,1,0,0v62.47a0,0,0,0,1,0,0H197a5.91,5.91,0,0,1-5.91-5.91V349.82A5.91,5.91,0,0,1,197,343.91Z",
    style: {
      fill: "#b5b5b5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.96,
    cy: 374.51,
    r: 4.1,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.03,
    y: 394.39,
    width: 2.84,
    height: 11.99,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.03,
    y: 376.09,
    width: 2.84,
    height: 11.99,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.63,280.32h-28v-1.53a1.5,1.5,0,0,0-3,0v24a1.5,1.5,0,0,0,3,0v-2.15h28a3.64,3.64,0,0,0,3.63-3.64V284A3.64,3.64,0,0,0,221.63,280.32Zm-28,2h19v16.3h-19ZM223.26,297a1.64,1.64,0,0,1-1.63,1.64h-7.09v-16.3h7.09a1.63,1.63,0,0,1,1.63,1.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.08 247.56 193.35 247.56 193.35 272.49 213.85 272.49 213.85 255.61 205.08 247.56",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.49,
    y: 254.91,
    width: 12.46,
    height: 13.94,
    rx: 2.51,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 202.6,
    y1: 255.16,
    x2: 202.6,
    y2: 268.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.49,
    y1: 262.14,
    x2: 208.82,
    y2: 262.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.48,268.74v-3.11a3.12,3.12,0,0,1,3.12-3.12h.11a3.13,3.13,0,0,1,3.13,3.12v3.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.84,255.63v3.11a3.13,3.13,0,0,1-3.13,3.12h-.11a3.12,3.12,0,0,1-3.12-3.12v-3.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tool-2--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.36,231.73a.5.5,0,0,0-.5-.5H381a.51.51,0,0,0-.5.5V246.4a.51.51,0,0,0,.15.35l4.13,50.61a.17.17,0,0,0,0,.07v52.32a.48.48,0,0,0,.18.38l2.77,17.12a.5.5,0,0,0,.49.42H389l.67,38.25a1.27,1.27,0,0,0,2.53,0l.66-38.26h.77a.51.51,0,0,0,.5-.42l2.76-17.12a.49.49,0,0,0,.19-.38V297.43a.17.17,0,0,1,0-.07l4.13-50.61a.5.5,0,0,0,.14-.35Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.39,406.67h0a.77.77,0,0,1-.76-.75l-.74-42.25h3l-.73,42.25A.77.77,0,0,1,388.39,406.67Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.2 246.44 378.61 246.44 382.77 297.32 382.78 297.32 382.78 349.75 394.04 349.75 394.04 297.32 394.05 297.32 398.2 246.44",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.49,
    y: 231.73,
    width: 19.83,
    height: 14.66,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.1 367.17 385.72 367.17 382.92 349.83 393.89 349.83 391.1 367.17",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tool-1--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.82,247a.53.53,0,0,0-.15-.33.88.88,0,0,0-1-.27c-1.44.6-1.58,6.62-1.6,22.4,0,9.52,0,20.32-.77,27.42a374.89,374.89,0,0,1-11,55.66A76.9,76.9,0,0,0,117.88,363a78.29,78.29,0,0,0-2.46-11.09,373.64,373.64,0,0,1-11-55.66c-.75-7.1-.76-17.9-.77-27.42,0-15.78-.15-21.8-1.59-22.4a.9.9,0,0,0-1,.27.47.47,0,0,0-.14.33c0,.51-2.21,51.3,1.5,72.61,1.66,9.5,3.52,19.08,5.32,28.34,2.26,11.63,4.21,21.68,5.18,28.64,1.38,9.88,1.36,22.39,1.28,27.31a2.36,2.36,0,0,0,2.35,2.37h2.62a2.34,2.34,0,0,0,2.34-2.37c-.07-4.92-.1-17.42,1.28-27.31,1-7,2.93-17,5.19-28.64,1.79-9.26,3.65-18.84,5.31-28.34C137,298.3,134.84,247.51,134.82,247ZM117.88,371.75a3.19,3.19,0,0,0,.1.35l-.1.09-.1-.09C117.81,372,117.84,371.89,117.88,371.75Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.13,247.28c-3-3-.75,32.75-2.5,49.25a372.77,372.77,0,0,1-11,55.75c-4.5,15.5-2.25,20.25-2.25,20.25l-.69.56c-.39-.33-.69-.56-.69-.56s2.25-4.75-2.25-20.25a372.77,372.77,0,0,1-11-55.75c-1.75-16.5.5-52.25-2.5-49.25,0,0-2.25,51,1.5,72.5s8.75,44.5,10.5,57c1.4,10,1.36,22.68,1.29,27.38a1.84,1.84,0,0,0,1.84,1.87H117a1.84,1.84,0,0,0,1.84-1.87c-.07-4.7-.1-17.4,1.29-27.38,1.75-12.5,6.75-35.5,10.5-57S132.13,247.28,132.13,247.28Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--hand-2--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.34,139.32a555.79,555.79,0,0,1,17.89-53.17l-40.85-1.59s-11.86,30.71-16.59,39.23-10.73,11-17.67,13.88-26.5,15.14-28.4,19.88-4.1,18.93-6,23.66-5.68,7.25-11.36,8.83c-1.11.31-2.24.6-3.32.88l-.08,0-1.07.28-.57.15-.37.1-.51.15-.36.11-.51.16-.3.09-.73.26-.14.06c-.19.07-.37.14-.54.22l-.23.1-.39.2-.21.11-.35.21-.15.11a3.53,3.53,0,0,0-.41.34l0,0a2.61,2.61,0,0,0-.27.33.83.83,0,0,0-.07.13,1.59,1.59,0,0,0-.12.27.88.88,0,0,0-.05.15,1.39,1.39,0,0,0,0,.3.65.65,0,0,0,0,.14,1.56,1.56,0,0,0,.09.46c.94,2.84,10.09,4.74,19.24,3.48s12.62-3.79,15.46-7.58,7.57-12,9.46-12.93l1.9-1s-.32,33.76.31,37.86-2.84,18.3-9.78,35.34a43.83,43.83,0,0,0-3.52,17.16v.08a31,31,0,0,0,.31,4v0a28,28,0,0,0,.7,3.39v0c.09.32.19.64.28.94l0,.05c.2.62.41,1.19.62,1.7l0,0c.1.23.19.45.29.65l.06.13q.14.29.27.54a.56.56,0,0,1,0,.08c.1.19.2.37.31.54l0,.05c.09.14.17.28.26.4l.08.12.2.27.08.09.26.29c2.21,2.21,6.62,2.21,7.57,1.26s.32-13.57,2.21-21.77,12.93-30,16.09-34.39a114.86,114.86,0,0,0,6.62-11,136.58,136.58,0,0,1-7.88,30c-6.31,16.41-12.94,27.13-14.2,31.87s3.47,7.57,6.31,6.31,8.83-13.89,11-18.3S342.84,250,342.84,250A10.11,10.11,0,0,0,352,246.2c.46-.58.95-1.23,1.46-1.92a11.93,11.93,0,0,0,5.48-.61c4.73-1.57,4.42-6.31,6.31-11a20.74,20.74,0,0,1,3.18-5.18,10.86,10.86,0,0,0,3.44-3.65c.94-2.33,2.39-19.65,3.84-32.86A213.28,213.28,0,0,1,383.34,139.32Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-4)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.86,219.8s-4.73,4.1-6.62,8.83-1.58,9.47-6.31,11-7.57,0-7.57,0,3.78-9.46,6-12.62S366.86,219.8,366.86,219.8Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.86,219.8s-4.73,4.1-6.62,8.83-1.58,9.47-6.31,11-7.57,0-7.57,0,3.78-9.46,6-12.62S366.86,219.8,366.86,219.8Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M366.86,219.8s-4.73,4.1-6.62,8.83-1.58,9.47-6.31,11-7.57,0-7.57,0,3.78-9.46,6-12.62S366.86,219.8,366.86,219.8Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.38,80.56s-11.86,30.71-16.59,39.23-10.73,11-17.67,13.88-26.5,15.14-28.4,19.88-4.1,18.93-6,23.66-5.68,7.25-11.36,8.83-11.67,2.53-10.72,5.36,10.09,4.74,19.24,3.48,12.62-3.79,15.46-7.58,7.57-12,9.46-12.93l1.9-1s-.32,33.76.31,37.86-2.84,18.3-9.78,35.34-1.89,28.39.32,30.6,6.62,2.21,7.57,1.26.32-13.57,2.21-21.77,12.93-30,16.09-34.39a114.86,114.86,0,0,0,6.62-11,136.58,136.58,0,0,1-7.88,30c-6.31,16.41-12.94,27.13-14.2,31.87s3.47,7.57,6.31,6.31,8.83-13.89,11-18.3S337.84,246,337.84,246A10.11,10.11,0,0,0,347,242.2c3.78-4.73,9.78-14.51,9.78-14.51s8.83-4.74,10.09-7.89,3.47-33.76,5.37-44.49,7.25-33.75,10.09-42.9,23.54-48.69,23.54-48.69",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-4)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.35,187.3c2.84-3.78,7.57-12,9.46-12.93l1.9-1s-4.71-9.09-9.38-2.42S290,187.67,284,188.33c-4.16.47-8-.67-11.95-1.41-4.44,1.14-8.16,2.2-7.4,4.48.94,2.84,10.09,4.74,19.24,3.48S296.51,191.09,299.35,187.3Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.73,262.33c-.23,8.17,2.4,13.46,3.83,14.89,2.21,2.21,6.62,2.21,7.57,1.26s.32-13.57,2.21-21.77,12.93-30,16.09-34.39a114.86,114.86,0,0,0,6.62-11S326.67,225,318.67,233C311.58,240.09,301.36,247.7,297.73,262.33Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.67,109.67a303.94,303.94,0,0,1-21.34,32c-14,18.66-14.66,42-16.66,52s-.67,19.33-8,30-12,19.33-12,19.33l-.62-31.72a136.58,136.58,0,0,1-7.88,30c-6.31,16.41-12.94,27.13-14.2,31.87s3.47,7.57,6.31,6.31,8.83-13.89,11-18.3S337.84,246,337.84,246A10.11,10.11,0,0,0,347,242.2c3.78-4.73,9.78-14.51,9.78-14.51s8.83-4.74,10.09-7.89,3.47-33.76,5.37-44.49,7.25-33.75,10.09-42.9c1.32-4.23,5.87-13.66,10.39-22.58Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.35,187.3c2.84-3.78,7.57-12,9.46-12.93l1.9-1s-4.71-9.09-9.38-2.42S290,187.67,284,188.33c-4.16.47-8-.67-11.95-1.41-4.44,1.14-8.16,2.2-7.4,4.48.94,2.84,10.09,4.74,19.24,3.48S296.51,191.09,299.35,187.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.73,262.33c-.23,8.17,2.4,13.46,3.83,14.89,2.21,2.21,6.62,2.21,7.57,1.26s.32-13.57,2.21-21.77,12.93-30,16.09-34.39a114.86,114.86,0,0,0,6.62-11S326.67,225,318.67,233C311.58,240.09,301.36,247.7,297.73,262.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.67,109.67a303.94,303.94,0,0,1-21.34,32c-14,18.66-14.66,42-16.66,52s-.67,19.33-8,30-12,19.33-12,19.33l-.62-31.72a136.58,136.58,0,0,1-7.88,30c-6.31,16.41-12.94,27.13-14.2,31.87s3.47,7.57,6.31,6.31,8.83-13.89,11-18.3S337.84,246,337.84,246A10.11,10.11,0,0,0,347,242.2c3.78-4.73,9.78-14.51,9.78-14.51s8.83-4.74,10.09-7.89,3.47-33.76,5.37-44.49,7.25-33.75,10.09-42.9c1.32-4.23,5.87-13.66,10.39-22.58Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M355.38,80.56s-11.86,30.71-16.59,39.23-10.73,11-17.67,13.88-26.5,15.14-28.4,19.88-4.1,18.93-6,23.66-5.68,7.25-11.36,8.83-11.67,2.53-10.72,5.36,10.09,4.74,19.24,3.48,12.62-3.79,15.46-7.58,7.57-12,9.46-12.93l1.9-1s-.32,33.76.31,37.86-2.84,18.3-9.78,35.34-1.89,28.39.32,30.6,6.62,2.21,7.57,1.26.32-13.57,2.21-21.77,12.93-30,16.09-34.39a114.86,114.86,0,0,0,6.62-11,136.58,136.58,0,0,1-7.88,30c-6.31,16.41-12.94,27.13-14.2,31.87s3.47,7.57,6.31,6.31,8.83-13.89,11-18.3S337.84,246,337.84,246A10.11,10.11,0,0,0,347,242.2c3.78-4.73,9.78-14.51,9.78-14.51s8.83-4.74,10.09-7.89,3.47-33.76,5.37-44.49,7.25-33.75,10.09-42.9,23.54-48.69,23.54-48.69",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336,206.33s2.67-1.33,3.33-6a68.17,68.17,0,0,0,.67-8.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.84,246s9.78-17.66,11.36-18.61,6.62-3.79,6.94-8.2.63-9.78.63-9.78",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--hand-1--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.39,83s10.76,38.4,13,43.13,14.19,12.3,16.4,22.71,5.05,14.83,7.57,22.72,4.74,7.89.95,14.51-4.42,10.73-1.89,14.83,15.46,9.46,13.88,12.62-3.16,4.1-4.42,4.1h-1.26s2.84,10.41,1.26,14.2-5.36,6.31-6.62,4.41-3.47-4.73-3.47-4.73,2.52,5.05-.63,5.68-3.79-.31-8.52-2.52-15.46-4.42-15.46-4.42-12.62,5-16.72,6.31-9.15-.32-9.15-.32-13.57,5.37-15.78,1-3.78-22.71-4.73-26.18-4.1-6.31-3.47-11.68,2.21-8.52,2.53-10.72,8.51-42.28,8.51-51.11-15.45-53-15.45-53",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,162.06s5,21.14,7.89,28.4,5.67,14.83,8.83,17.67,12.62,7.88,13.88,9.46",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.22,185.73s20.19,29,23,33.44,11.36,4.41,13.57,6.31l6.94,6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,193.93s8.52,10.41,15.46,20.82,7.58,12.94,11,13.88,11.67,1.58,11.67,1.58",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.35,210s14.51,19.56,15.77,22.4a7.81,7.81,0,0,0,3.16,3.78",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.9,165.53s-6.62,3.48-5.67,6.31a38.39,38.39,0,0,0,2.52,5.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.24,176.26s-6,1.89-6.31,5.36a12,12,0,0,0,1.26,6.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.33,
    y: 216.89,
    width: 46.61,
    height: 5.33,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.44,92.89s15.71,35.14,17.92,39.88,14.19,12.3,16.4,22.71,5.05,14.83,7.57,22.72,4.74,7.88.95,14.51-4.42,10.72-1.89,14.83,15.46,9.46,13.88,12.62-3.16,4.1-4.42,4.1h-1.26s2.84,10.41,1.26,14.19-5.36,6.31-6.62,4.42-3.47-4.73-3.47-4.73,2.52,5.05-.63,5.68-3.79-.32-8.52-2.53-15.46-4.41-15.46-4.41-12.62,5-16.72,6.31-9.15-.32-9.15-.32-13.57,5.36-15.78.95-3.78-22.72-4.73-26.19-4.1-6.31-3.47-11.67,2.21-8.52,2.53-10.73,8.51-42.27,8.51-51.11-15.45-53-15.45-53",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.39,83s10.76,38.4,13,43.13,14.19,12.3,16.4,22.71,5.05,14.83,7.57,22.72,4.74,7.89.95,14.51-4.42,10.73-1.89,14.83,15.46,9.46,13.88,12.62-3.16,4.1-4.42,4.1h-1.26s2.84,10.41,1.26,14.2-5.36,6.31-6.62,4.41-3.47-4.73-3.47-4.73,2.52,5.05-.63,5.68-3.79-.31-8.52-2.52-15.46-4.42-15.46-4.42-12.62,5-16.72,6.31-9.15-.32-9.15-.32-13.57,5.37-15.78,1-3.78-22.71-4.73-26.18-4.1-6.31-3.47-11.68,2.21-8.52,2.53-10.72,8.51-42.28,8.51-51.11-15.45-53-15.45-53",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-4)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162,231a74.05,74.05,0,0,1-11.88,1.42s.22,7.55-12.62,4.73c2.21,4.42,15.78-1,15.78-1s5.05,1.58,9.15.32,16.72-6.31,16.72-6.31,10.73,2.21,15.46,4.42,5.36,3.15,8.52,2.52.63-5.68.63-5.68,2.21,2.84,3.47,4.73,5-.63,6.62-4.41-1.26-14.2-1.26-14.2h1.26c1.26,0,2.84-1,4.42-4.1s-11.36-8.52-13.88-12.62-1.9-8.2,1.89-14.83,1.58-6.62-.95-14.51-5.36-12.3-7.57-22.72c-2-9.42-12-16.52-15.53-21.29a96.28,96.28,0,0,0,9.1,18.15c9.34,14,10,27.33,7.34,34.66s-5.34,13.34-5.34,13.34L184,173s1.33,20,4,24.67,4,10,8.67,14,11.33,8.66,6,8.66-19.42-1.16-19.42-1.16,1.42,5.16-5.92,5.16a73.8,73.8,0,0,1-15.33-2S168.67,229.67,162,231Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,231a74.05,74.05,0,0,1-11.88,1.42s.22,7.55-12.62,4.73c2.21,4.42,15.78-1,15.78-1s5.05,1.58,9.15.32,16.72-6.31,16.72-6.31,10.73,2.21,15.46,4.42,5.36,3.15,8.52,2.52.63-5.68.63-5.68,2.21,2.84,3.47,4.73,5-.63,6.62-4.41-1.26-14.2-1.26-14.2h1.26c1.26,0,2.84-1,4.42-4.1s-11.36-8.52-13.88-12.62-1.9-8.2,1.89-14.83,1.58-6.62-.95-14.51-5.36-12.3-7.57-22.72c-2-9.42-12-16.52-15.53-21.29a96.28,96.28,0,0,0,9.1,18.15c9.34,14,10,27.33,7.34,34.66s-5.34,13.34-5.34,13.34L184,173s1.33,20,4,24.67,4,10,8.67,14,11.33,8.66,6,8.66-19.42-1.16-19.42-1.16,1.42,5.16-5.92,5.16a73.8,73.8,0,0,1-15.33-2S168.67,229.67,162,231Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M168.39,83s10.76,38.4,13,43.13,14.19,12.3,16.4,22.71,5.05,14.83,7.57,22.72,4.74,7.89.95,14.51-4.42,10.73-1.89,14.83,15.46,9.46,13.88,12.62-3.16,4.1-4.42,4.1h-1.26s2.84,10.41,1.26,14.2-5.36,6.31-6.62,4.41-3.47-4.73-3.47-4.73,2.52,5.05-.63,5.68-3.79-.31-8.52-2.52-15.46-4.42-15.46-4.42-12.62,5-16.72,6.31-9.15-.32-9.15-.32-13.57,5.37-15.78,1-3.78-22.71-4.73-26.18-4.1-6.31-3.47-11.68,2.21-8.52,2.53-10.72,8.51-42.28,8.51-51.11-15.45-53-15.45-53",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,162.06s5,21.14,7.89,28.4,5.67,14.83,8.83,17.67,12.62,7.88,13.88,9.46",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.22,185.73s20.19,29,23,33.44,11.36,4.41,13.57,6.31l6.94,6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,193.93s8.52,10.41,15.46,20.82,7.58,12.94,11,13.88,11.67,1.58,11.67,1.58",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.35,210s14.51,19.56,15.77,22.4a7.81,7.81,0,0,0,3.16,3.78",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.9,165.53s-6.62,3.48-5.67,6.31a38.39,38.39,0,0,0,2.52,5.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.24,176.26s-6,1.89-6.31,5.36a12,12,0,0,0,1.26,6.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductteardownBro);
export default __webpack_public_path__ + "static/media/Product teardown-bro.410004aeda70f142a4093d3e7de4dc8f.svg";
export { ForwardRef as ReactComponent };